import React, { useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { General, GeneralQuality } from "../../../../lib/types";
import { openTooltip } from "../../../../store/actions";
import { getGeneralSkillName } from "../../../../lib/commonFunctions";

interface IProps {
  general: General;
  available: boolean;
  skill?: GeneralQuality;
  strengthBonusLevel?: number;
  tier?: number;
  economist?: boolean;
  clickable: boolean;
}

const mapDispatchToProps = (dispatch: any) => ({
  openTooltipDispatch: (tooltipOptions: any) => dispatch(openTooltip(tooltipOptions)),
});

const connector = connect(null, mapDispatchToProps);


const GeneralSkillIcon = ({
  general,
  skill,
  strengthBonusLevel,
  tier,
  openTooltipDispatch,
  available,
  economist,
  clickable
}: IProps & ConnectedProps<typeof connector>) => {
  const iconRef = useRef<HTMLAnchorElement>(null);

  const tooltipOptions = skill ? {
    name: "GeneralSkillInfo",
    dynamic: true,
    classes: ["rich-tooltip", "text-center"],
    available,
    generalId: general.id,
    skill,
    exclusive: skill.exclusive ? getGeneralSkillName(general, skill.exclusive) : undefined,
    elementRef: iconRef
  } : {
    name: "GeneralStrengthBonusInfo",
    dynamic: true,
    classes: ["rich-tooltip", "text-center"],
    available,
    generalId: general.id,
    tier,
    economist,
    elementRef: iconRef
  }

  return (
    <span className={`point ${(skill && skill.level > 0) || strengthBonusLevel ? "active" : (available ? "available" : "")}`}>
      <a
        ref={iconRef}
        onClick={() => clickable && openTooltipDispatch(tooltipOptions)}
      >
        {(skill && skill.level) || (strengthBonusLevel || "0")}/{skill ? (skill.tier === 4 ? "2" : "4") : "1"}
      </a>
    </span>
  )
}

export default connector(GeneralSkillIcon);
